module.exports = __webpack_public_path__ + "img/logo-tate.b726abf0.png";